import { useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import * as api from '~services/api';
import { addToast } from '~features/toast/ducks';

import { Button } from '~ui-kit';

const NumberLookup = ({ onChange, error, value }) => {
  const dispatch = useDispatch();
  const organizations = useSelector(state => state.reducer.organizations);
  const [number, setNumber] = useState('');
  const [account, setAccount] = useState();

  const handleSearch = async () => {
    console.debug('searching for number', number);
    try {
      const newAccount = await api.get(`data/maintenance/extensions/${number}`);
      console.debug('found account', newAccount);
      if (newAccount) {
        onChange(newAccount.telNro);

        // These are just for UI representation
        let accountUnit;
        if (newAccount.organizationId) {
          accountUnit = organizations.find(
            o => o.id.toString() === newAccount.organizationId
          );
        }

        setAccount({
          ...newAccount,
          type: accountUnit ? 'unit' : 'code',
          label: accountUnit ? accountUnit.name : newAccount.costCentreCode,
        });
      }
    } catch (error) {
      console.error('Error in handleSearch:', error);
      dispatch(
        addToast({
          type: 'ERROR',
          message: 'Numerolla ei löytynyt liittymää',
        })
      );
    }
  };

  return (
    <Container>
      <FieldContainer>
        <Field
          type="tel"
          className="form-control"
          value={number}
          onChange={event => setNumber(event.target.value)}
          error={error}
        />
        <Button type="button" onClick={handleSearch}>
          Hae
        </Button>
      </FieldContainer>
      {account && (
        <Account>
          <FontAwesomeIcon icon={faInfoCircle} />
          Numero &nbsp;<strong>{value}</strong>&nbsp; löytyi{' '}
          {account.type === 'unit' ? 'yksiköltä' : 'kustannuspaikalta'}
          &nbsp;
          <strong>{account.label}</strong>
        </Account>
      )}
    </Container>
  );
};

const Container = styled.div``;

const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Field = styled.input`
  max-width: 250px;
  ${p => p.error && 'border-color: var(--errorColor)'};
`;

const Account = styled.div`
  margin-top: 16px;
  padding: 8px;
  border: 1px solid var(--infoColor);
  background-color: var(--infoColorLight);
  border-radius: 4px;
  color: var(--infoColor);
  font-size: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  & i {
    margin-right: 6px;
  }
`;

export default NumberLookup;
